import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';
import { ReactComponent as Download } from 'images/icon_download.svg';
import { ReactComponent as Upload } from 'images/icon_upload.svg';
import { ReactComponent as Delete } from 'images/icon_trash.svg';
import { ReactComponent as ArrowDown } from 'images/icon_arrow_down.svg';
import { ReactComponent as ArrowRight } from 'images/icon_arrow_right.svg';
import { ReactComponent as Calendar } from 'images/icon_calendar.svg';
import { ReactComponent as Close } from 'images/icon_close.svg';
import { ReactComponent as BorderClose } from 'images/icon_close_border.svg';
import { ReactComponent as Save } from 'images/icon_save.svg';
import { ReactComponent as Help } from 'images/icon_help.svg';
import { ReactComponent as Search } from 'images/icon_search.svg';
import { ReactComponent as SubmitFilter } from 'images/icon_submit_filter.svg';
import { ReactComponent as Create } from 'images/new/add_circle.svg';
import { ReactComponent as AccountView } from 'images/icon_account_view.svg';
import { ReactComponent as ManagerialView } from 'images/icon_managerial_view.svg';
import { ReactComponent as OperationalView } from 'images/icon_srm_opertational_view.svg';
import { ReactComponent as CleanerOperationalView } from 'images/icon_crm_opertational_view.svg';
import { ReactComponent as MaintenanceOperationalView } from 'images/icon_maintenance_operational_view.svg';
import { ReactComponent as EmergencyView } from 'images/icon_emergency_view.svg';
import { ReactComponent as ReportingView } from 'images/icon_reporting_view.svg';
import { ReactComponent as TransportView } from 'images/icon_transport_view.svg';
import { ReactComponent as Logout } from 'images/icon_log_out.svg';
import { ReactComponent as Canine } from 'images/icon_asset_canine.svg';
import { ReactComponent as Firearm } from 'images/icon_asset_firearm.svg';
import { ReactComponent as Phone } from 'images/icon_asset_phone.svg';
import { ReactComponent as Consumable } from 'images/icon_consumables.svg';
import { ReactComponent as Disposable } from 'images/icon_disposables.svg';
import { ReactComponent as Tools } from 'images/icon_tools.svg';
import { ReactComponent as PPE } from 'images/icon_ppe.svg';
import { ReactComponent as Radio } from 'images/icon_radio.svg';
import { ReactComponent as Send } from 'images/icon_send.svg';
import { ReactComponent as RegionView } from 'images/icon_map.svg';
import { ReactComponent as AddLocationType } from 'images/icon_add_location_type.svg';
import { ReactComponent as MarkerDrawingMenu } from 'images/icon_add_location_point.svg';
import { ReactComponent as PolygonDrawingMenu } from 'images/icon_add_polygon_perimeter.svg';
import { ReactComponent as RectangleDrawingMenu } from 'images/icon_add_square_perimeter.svg';
import { ReactComponent as EllipseDrawingMenu } from 'images/icon_add_circle_perimeter.svg';
import { ReactComponent as VehicleAsset } from 'images/icon_asset_vehicle.svg';
import { ReactComponent as MapSlider } from 'images/new/height.svg';
import { ReactComponent as EventsNotification } from 'images/new/circle_notifications.svg';
import { ReactComponent as Dashboard } from 'images/new/dashboard.svg';
import { ReactComponent as TaskAssignment } from 'images/new/assignment.svg';
import { ReactComponent as PeopleBadge } from 'images/new/badge.svg';
import { ReactComponent as Assets } from 'images/new/sell.svg';
import { ReactComponent as Locations } from 'images/new/map.svg';
import { ReactComponent as CalendarNewIcon } from 'images/new/calendar.svg';
import { ReactComponent as AdminPanel } from 'images/new/settings_applications.svg';
import { ReactComponent as Messages } from 'images/new/chat_bubble.svg';
import { ReactComponent as ThemePalette } from 'images/new/palette.svg';
import { ReactComponent as Edit } from 'images/new/edit.svg';
import { ReactComponent as Refresh } from 'images/new/refresh.svg';

import { BASE_ASSET_CATEGORY } from '../utils/constants/assetText';
// import { Box } from '@material-ui/core';
// import { withStyles } from '@material-ui/core/styles';

// const WithBackground = withStyles(theme => ({
//   root: {
//     background: theme.palette.primary.main,
//     color: theme.palette.text.primary,
//   },
// }))(Box);

// New Icons
export const EventsNotificationIcon = props => (
  <SvgIcon component={EventsNotification} {...props} />
);
export const DashboardIcon = props => (
  <SvgIcon component={Dashboard} {...props} />
);
export const TaskAssignmentIcon = props => (
  <SvgIcon component={TaskAssignment} {...props} />
);
export const PeopleBadgeIcon = props => (
  <SvgIcon component={PeopleBadge} {...props} />
);
export const AssetsIcon = props => <SvgIcon component={Assets} {...props} />;
export const MapIcon = props => <SvgIcon component={Locations} {...props} />;
export const CalendarIcon_New = props => (
  <SvgIcon component={CalendarNewIcon} {...props} />
);
export const AdminPanelIcon = props => (
  <SvgIcon component={AdminPanel} {...props} />
);
export const MessagesIcon = props => (
  <SvgIcon component={Messages} {...props} />
);
export const ThemeIcon = props => (
  <SvgIcon component={ThemePalette} {...props} />
);
export const EditIcon = props => <SvgIcon component={Edit} {...props} />;
export const RefreshIcon = props => <SvgIcon component={Refresh} {...props} />;
//-----------------------------------------------------------
export const DeleteIcon = props => <SvgIcon component={Delete} {...props} />;

export const DownloadIcon = props => (
  <SvgIcon component={Download} {...props} />
);

export const UploadIcon = props => <SvgIcon component={Upload} {...props} />;

export const ArrowDownIcon = props => (
  <SvgIcon component={ArrowDown} {...props} />
);

export const SendIcon = props => <SvgIcon component={Send} {...props} />;

export const CalendarIcon = props => (
  <SvgIcon component={Calendar} {...props} />
);

export const CloseIcon = props => <SvgIcon component={Close} {...props} />;

export const BorderedCloseIcon = props => (
  <SvgIcon component={BorderClose} {...props} />
);

export const ArrowRightIcon = props => (
  <SvgIcon component={ArrowRight} {...props} />
);
export const MapSliderIcon = props => (
  <SvgIcon component={MapSlider} {...props} />
);

export const SaveIcon = props => <SvgIcon component={Save} {...props} />;

export const HelpIcon = props => <SvgIcon component={Help} {...props} />;

export const SearchIcon = props => <SvgIcon component={Search} {...props} />;

export const SubmitFilterIcon = props => (
  <SvgIcon component={SubmitFilter} {...props} />
);

export const CreateIcon = props => <SvgIcon component={Create} {...props} />;

export const AccountViewIcon = props => (
  <SvgIcon component={AccountView} {...props} />
);

export const ManagerialViewIcon = props => (
  <SvgIcon component={ManagerialView} {...props} />
);

export const OperationalViewIcon = props => (
  <SvgIcon component={OperationalView} {...props} />
);

export const CleanerOperationalViewIcon = props => (
  <SvgIcon component={CleanerOperationalView} {...props} />
);

export const MaintenanceOperationalViewIcon = props => (
  <SvgIcon component={MaintenanceOperationalView} {...props} />
);

export const EmergencyViewIcon = props => (
  <SvgIcon component={EmergencyView} {...props} />
);

export const ReportingViewIcon = props => (
  <SvgIcon component={ReportingView} {...props} />
);

export const RegionViewIcon = props => (
  <SvgIcon component={RegionView} {...props} />
);

export const TransportViewIcon = props => (
  <SvgIcon component={TransportView} {...props} />
);

export const VehicleAssetIcon = props => (
  <SvgIcon component={VehicleAsset} {...props} />
);

export const LogoutIcon = props => <SvgIcon component={Logout} {...props} />;

export const CanineIcon = props => <SvgIcon component={Canine} {...props} />;

export const FirearmIcon = props => <SvgIcon component={Firearm} {...props} />;

export const PhoneIcon = props => <SvgIcon component={Phone} {...props} />;

export const ConsumableIcon = props => (
  <SvgIcon component={Consumable} {...props} />
);

export const RadioIcon = props => <SvgIcon component={Radio} {...props} />;

export const DisposableIcon = props => (
  <SvgIcon component={Disposable} {...props} />
);
export const ToolsIcon = props => <SvgIcon component={Tools} {...props} />;
export const PPEIcon = props => <SvgIcon component={PPE} {...props} />;

export const AddLocationTypeIcon = props => (
  <SvgIcon component={AddLocationType} {...props} />
);

export const MarkerDrawingMenuIcon = props => (
  <SvgIcon component={MarkerDrawingMenu} {...props} />
);
export const PolygonDrawingMenuIcon = props => (
  <SvgIcon component={PolygonDrawingMenu} {...props} />
);
export const RectangleDrawingMenuIcon = props => (
  <SvgIcon component={RectangleDrawingMenu} {...props} />
);
export const EllipseDrawingMenuIcon = props => (
  <SvgIcon component={EllipseDrawingMenu} {...props} />
);

// FIX-ME: TO REFACTOR
export const icons = {
  CANINE: CanineIcon,
  FIREARM: FirearmIcon,
  PHONE: PhoneIcon,
  VEHICLE: VehicleAssetIcon,
  VEHICLE_OFF_ROAD: TransportViewIcon,
  VEHICLE_VAN: TransportViewIcon,
  VEHICLE_BUS: TransportViewIcon,
  CONSUMABLE: ConsumableIcon,
  [BASE_ASSET_CATEGORY.CONSUMABLE.id]: ConsumableIcon,
  [BASE_ASSET_CATEGORY.TOOLS_EQUIPMENT.id]: ToolsIcon,
  [BASE_ASSET_CATEGORY.PPE.id]: PPEIcon,
  [BASE_ASSET_CATEGORY.DISPOSABLE.id]: DisposableIcon,
  [BASE_ASSET_CATEGORY.RADIO.id]: RadioIcon,
};
